
import { Vue, Component, Prop } from "vue-property-decorator";
import IconButton from "@/components/UI/IconButton.vue";

@Component({
  components: {
    IconButton
  }
})
export default class PanelHeader extends Vue {
  @Prop({ default: false })
  backInsteadOfClose!: boolean;

  close() {
    this.$emit("close");
  }
}
